import styles from './style.module.scss';
import { Col, Divider, Row, Spin, Table, Typography } from 'antd';
import useKpiWeekdaysHolidays from '../useKpiWeekdaysHolidays';
import UIHelper from '../../../../../helpers/UIHelper';
import BarChangeChart from '../../../charts/barChange';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const { data, columns, title, loading, searchParams, columns2, filters } =
    useKpiWeekdaysHolidays(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        <Spin spinning={loading}>
          {!allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
              <PrintFilterText
                availableFilters={availableFilters}
                searchParams={searchParams}
              />
            </Row>
          )}
          {allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>KPIs by DAY TYPE</Typography.Title>
              </Col>
            </Row>
          )}
          <br />
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <BarChangeChart
                keys={data.keys}
                data={data}
                hideLine
                // format={format}
              />
            </Col>
            <Divider />
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(columns)}
                dataSource={data.table1}
                pagination={{
                  pageSize: 10,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{}}
              />
            </Col>
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(columns2)}
                dataSource={data.table2}
                pagination={{
                  pageSize: 10,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{}}
              />
            </Col>
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(columns)}
                dataSource={data.table3}
                pagination={{
                  pageSize: 10,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{}}
              />
            </Col>
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(columns)}
                dataSource={data.table4}
                pagination={{
                  pageSize: 10,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{}}
                // showHeader={false}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default Print;
